/* @flow */
import { css, names } from 'linaria';
import * as React from 'react';
import Image from './Image';

export default function Logo({
  className,
  theme = 'light',
}: {
  className: string,
  theme: 'light' | 'dark',
}) {
  return (
    <Image
      className={names(Style, className)}
      src={
        theme === 'light'
          ? require('../../../assets/images/logo-dark.svg')
          : require('../../../assets/images/logo-light.svg')
      }
    />
  );
}

const Style = css`
  width: 100%;
`;



// WEBPACK FOOTER //
// ./src/ui/components/core/Logo.js